import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { GetCreditTypesResponseDto } from './dto/response/get-credit-types-response.dto';
import { CreditUsageListResponseDto } from './dto/response/credit-usage-list-response.dto';
import { GetCompanyUsageCreditResponseDto } from './dto/response/get-company-usage-credits-response.dto';
import { GetCompanyManagementCreditResponseDto } from './dto/response/get-company-management-credits-response.dto';

const CUSTOMERS_PATH = HttpPathsEnum.CUSTOMERS;

class CreditsManagementApi {
  public async getCompanyManagementCredits() {
    const request: HttpRequest = {
      url: `${CUSTOMERS_PATH}/credit/management/`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<
      any,
      GetCompanyManagementCreditResponseDto[]
    >(request, GetCompanyManagementCreditResponseDto);
  }

  public async getCompanyCreditBalances() {
    const request: HttpRequest = {
      url: `${CUSTOMERS_PATH}/credit/balances`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetCompanyUsageCreditResponseDto[]>(
      request,
      GetCompanyUsageCreditResponseDto
    );
  }

  public async getCompanyCreditUsageList(creditBalanceId: number) {
    const request: HttpRequest = {
      url: `${CUSTOMERS_PATH}/order/orders-by-credit-balance/${creditBalanceId}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, CreditUsageListResponseDto[]>(
      request,
      CreditUsageListResponseDto
    );
  }

  public async getCreditTypes() {
    const request: HttpRequest = {
      url: `${CUSTOMERS_PATH}/credit/credit-types`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetCreditTypesResponseDto[]>(
      request,
      GetCreditTypesResponseDto
    );
  }
}

export default new CreditsManagementApi();
